function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
export default {
    lockPageScroll: lockPageScroll,
    unlockPageScroll: unlockPageScroll
};
export function lockPageScroll(scrollLock, setElementWithLockedScroll) {
    if (typeof scrollLock === 'boolean') {
        lockBodyScroll(setElementWithLockedScroll);
    } else if (typeof scrollLock === 'string') {
        lockIdScroll(scrollLock, setElementWithLockedScroll);
    } else if (_instanceof(scrollLock, Object)) {
        if (typeof scrollLock !== 'string' && typeof scrollLock !== 'boolean') {
            lockRefScroll(scrollLock, setElementWithLockedScroll);
        }
    }
}
export function unlockPageScroll(elementWithLockedScroll, setElementWithLockedScroll) {
    if (elementWithLockedScroll) {
        var _elementWithLockedScroll = _slicedToArray(elementWithLockedScroll, 2), element = _elementWithLockedScroll[0], overflowValue = _elementWithLockedScroll[1];
        element.style.overflow = overflowValue;
        setElementWithLockedScroll(undefined);
    }
}
function lockBodyScroll(setElementWithLockedScroll) {
    applyLockToElement(document.body, setElementWithLockedScroll);
}
function lockIdScroll(id, setElementWithLockedScroll) {
    var element = document.getElementById(id);
    if (element) {
        applyLockToElement(element, setElementWithLockedScroll);
    }
}
function isRefObject(ref) {
    return ref.hasOwnProperty('current');
}
function lockRefScroll(ref, setElementWithLockedScroll) {
    if (isRefObject(ref)) {
        if (_instanceof(ref.current, Element)) {
            applyLockToElement(ref.current, setElementWithLockedScroll);
        }
    } else if (_instanceof(ref, Element)) {
        applyLockToElement(ref, setElementWithLockedScroll);
    }
}
function applyLockToElement(element, setElementWithLockedScroll) {
    var scrollTop = element.scrollTop;
    var currentOverflow = element.style.overflow;
    element.style.overflow = 'hidden';
    element.scrollTop = scrollTop;
    setElementWithLockedScroll([
        element,
        currentOverflow
    ]);
}
